import React from 'react';
import { Button } from '../components/ui/button';
import AnimatedPage from '../components/AnimatedPage';

const Contact = () => {
  return (
    <AnimatedPage className="min-h-screen bg-stone-50">
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-stone-50 via-stone-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-4">
              Contact Us
            </h1>
            <div className="h-1 w-24 bg-gradient-to-r from-amber-500 via-amber-500 to-orange-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* MDVIP Instructions Section */}
      <section className="py-16 bg-stone-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-stone-50 to-amber-50 p-10 rounded-2xl border-2 border-stone-100 shadow-xl">
            <h2 className="text-3xl font-bold text-stone-900 mb-6 text-center">
              Start Your Journey with MDVIP
            </h2>
            
            <p className="text-stone-700 leading-relaxed mb-8 text-center">
              To schedule an appointment or learn more about our services, please
              begin by enrolling through MDVIP's secure enrollment portal.
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="bg-stone-600 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 text-base font-bold">
                  1
                </div>
                <p className="text-stone-700 leading-relaxed">
                  Click the "Join MDVIP" button below to access the enrollment portal
                </p>
              </div>
              <div className="flex items-start space-x-4">
                <div className="bg-stone-600 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 text-base font-bold">
                  2
                </div>
                <p className="text-stone-700 leading-relaxed">
                  Complete the enrollment process with your information
                </p>
              </div>
              <div className="flex items-start space-x-4">
                <div className="bg-stone-600 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 text-base font-bold">
                  3
                </div>
                <p className="text-stone-700 leading-relaxed">
                  Our team will contact you to schedule your comprehensive wellness visit
                </p>
              </div>
            </div>

            <a
              href="https://www.mdvip.com/doctors/allisonwilliamsmd"
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            >
              <Button className="w-full bg-gradient-to-r from-orange-400 via-amber-500 to-orange-600 hover:from-orange-500 hover:via-amber-600 hover:to-orange-700 text-white font-bold py-4 text-lg shadow-lg hover:shadow-xl transition-all duration-300">
                Join MDVIP Now
              </Button>
            </a>

            <p className="text-sm text-stone-500 mt-6 text-center">
              Questions? Call us at (410) 721-3822 for assistance
            </p>
          </div>
        </div>
      </section>
    </AnimatedPage>
  );
};

export default Contact;
